import { render, staticRenderFns } from "./CoTableColumnSelector.vue?vue&type=template&id=8f2cab26&"
import script from "./CoTableColumnSelector.vue?vue&type=script&lang=ts&"
export * from "./CoTableColumnSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports